export default class Prefectures {
  constructor(country, postcode, prefectures) {
    this.country = country;
    this.postcode = postcode;
    this.prefectures = prefectures;
    this.select = country.getElementsByTagName("select")[0];
    this.onlyJapan = document.querySelectorAll('.f-onlyJapan');

    this.setup()
  }

  setup () {
    this.select.addEventListener('change', (event) => {
      const _index = this.select.selectedIndex;
      const _value = this.select.options[_index].value;
      // if(_value=="JP")
      if(_index==0)
      {
        this.postcode.classList.remove("off");
        this.prefectures.classList.remove("off");
        this.onlyJapan.forEach((elm, index) => {
          elm.classList.remove("off");
          elm.setAttribute("required", true);
        });
      }
      else
      {
        this.postcode.classList.add("off");
        this.prefectures.classList.add("off");
        this.onlyJapan.forEach((elm, index) => {
          elm.classList.add("off");
          elm.removeAttribute("required");
        });
      }
    });
  }

}